/* ============================================================
   YOOME THEME — Main JavaScript
   ============================================================ */

(function() {
  'use strict';

  // ---- Utility ----
  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.from((context || document).querySelectorAll(selector)); }
  function on(el, event, handler, options) { if (el) el.addEventListener(event, handler, options); }
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = window.Yoome && window.Yoome.moneyFormat ? window.Yoome.moneyFormat : '${{amount}}';
    return format.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents/100));
  }

  // ---- Cart State ----
  var cart = { items: [], item_count: 0, total_price: 0 };

  // ---- Cart Drawer ----
  var cartDrawer = $('#CartDrawer');
  var cartOverlay = $('#CartDrawerOverlay');
  var cartDrawerBody = $('#CartDrawerBody');
  var cartCount = $$('.cart-count');
  var cartSubtotal = $('#CartSubtotal');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        cart = data;
        renderCart(data);
        updateCartCount(data.item_count);
      })
      .catch(function(e) { console.error('Cart fetch error:', e); });
  }

  function renderCart(cartData) {
    if (!cartDrawerBody) return;
    if (cartData.item_count === 0) {
      cartDrawerBody.innerHTML = '<div class="cart-drawer__empty">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p>Your cart is empty</p>' +
        '<a href="/collections/all" class="btn btn--primary">Continue Shopping</a>' +
        '</div>';
    } else {
      var html = cartData.items.map(function(item) {
        return '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item__image"><a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a></div>' +
          '<div class="cart-item__info">' +
            '<div class="cart-item__title"><a href="' + item.url + '">' + item.product_title + '</a></div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:1.2rem;color:rgba(26,31,46,0.5);margin-bottom:0.4rem;">' + item.variant_title + '</div>' : '') +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-item__qty">' +
              '<button class="cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
              '<span class="cart-item__qty-count">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
              '<button class="cart-item__qty-btn" data-action="remove" data-key="' + item.key + '" aria-label="Remove item" style="margin-left:0.4rem;font-size:1.2rem;opacity:0.5;">✕</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
      cartDrawerBody.innerHTML = html;
    }
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cartData.total_price);
  }

  function updateCartCount(count) {
    cartCount.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) { cart = data; renderCart(data); updateCartCount(data.item_count); })
    .catch(function(e) { console.error('Cart change error:', e); });
  }

  // Cart event delegation
  on(cartDrawerBody, 'click', function(e) {
    var btn = e.target.closest('.cart-item__qty-btn');
    if (!btn) return;
    var key = btn.dataset.key;
    var action = btn.dataset.action;
    var item = cart.items.find(function(i) { return i.key === key; });
    if (!item) return;
    if (action === 'increase') changeCartItem(key, item.quantity + 1);
    else if (action === 'decrease') changeCartItem(key, Math.max(0, item.quantity - 1));
    else if (action === 'remove') changeCartItem(key, 0);
  });

  on($('#CartToggle'), 'click', openCart);
  on($('#CartDrawerClose'), 'click', closeCart);
  on(cartOverlay, 'click', closeCart);

  // ---- Add to Cart ----
  function addToCart(variantId, quantity, properties, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1, properties: properties || {} })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Added!'; setTimeout(function() { btn.textContent = btn.dataset.originalText || 'Add to Cart'; }, 1500); }
      if (window.Yoome && window.Yoome.cartType === 'drawer') openCart();
      else window.location.href = '/cart';
    })
    .catch(function(e) {
      console.error('Add to cart error:', e);
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || 'Add to Cart'; }
    });
  }

  // Quick-add buttons
  on(document, 'click', function(e) {
    var btn = e.target.closest('.product-card__quick-add');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (variantId) addToCart(variantId, 1, {}, btn);
  });

  // Add to cart form
  on(document, 'submit', function(e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var submitBtn = form.querySelector('[type="submit"]');
    if (!variantInput) return;
    var variantId = variantInput.value;
    var qty = qtyInput ? parseInt(qtyInput.value) : 1;
    if (submitBtn) submitBtn.dataset.originalText = submitBtn.textContent;
    addToCart(variantId, qty, {}, submitBtn);
  });

  // ---- Search Drawer ----
  var searchDrawer = $('#SearchDrawer');
  var searchInput = $('#SearchInput');

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.add('open');
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 100);
  }
  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('open');
  }

  on($('#SearchToggle'), 'click', openSearch);
  on($('#SearchDrawerClose'), 'click', closeSearch);
  on(document, 'keydown', function(e) { if (e.key === 'Escape') { closeCart(); closeSearch(); } });

  // ---- Hero Slider ----
  var heroSlider = $('.hero-banner');
  if (heroSlider) {
    var slides = $$('.hero-banner__slide', heroSlider);
    var dots = $$('.hero-banner__dot', heroSlider);
    var current = 0;
    var autoplayTimer;

    function goToSlide(index) {
      slides[current].style.display = 'none';
      if (dots[current]) dots[current].classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].style.display = 'flex';
      if (dots[current]) dots[current].classList.add('active');
    }

    function startAutoplay() {
      autoplayTimer = setInterval(function() { goToSlide(current + 1); }, 5000);
    }

    if (slides.length > 1) {
      slides.forEach(function(s, i) { s.style.display = i === 0 ? 'flex' : 'none'; });
      if (dots[0]) dots[0].classList.add('active');
      on($('#HeroPrev'), 'click', function() { clearInterval(autoplayTimer); goToSlide(current - 1); startAutoplay(); });
      on($('#HeroNext'), 'click', function() { clearInterval(autoplayTimer); goToSlide(current + 1); startAutoplay(); });
      dots.forEach(function(dot, i) { on(dot, 'click', function() { clearInterval(autoplayTimer); goToSlide(i); startAutoplay(); }); });
      startAutoplay();
    }
  }

  // ---- Drag-to-scroll Carousels ----
  $$('.carousel-track-wrap').forEach(function(wrap) {
    var isDown = false;
    var startX;
    var scrollLeft;
    on(wrap, 'mousedown', function(e) { isDown = true; wrap.classList.add('dragging'); startX = e.pageX - wrap.offsetLeft; scrollLeft = wrap.scrollLeft; });
    on(wrap, 'mouseleave', function() { isDown = false; wrap.classList.remove('dragging'); });
    on(wrap, 'mouseup', function() { isDown = false; wrap.classList.remove('dragging'); });
    on(wrap, 'mousemove', function(e) { if (!isDown) return; e.preventDefault(); var x = e.pageX - wrap.offsetLeft; var walk = (x - startX) * 2; wrap.scrollLeft = scrollLeft - walk; });

    // Nav buttons
    var section = wrap.closest('.carousel-section');
    if (section) {
      var prevBtn = section.querySelector('.carousel-nav__btn--prev');
      var nextBtn = section.querySelector('.carousel-nav__btn--next');
      var track = wrap.querySelector('.carousel-track');
      on(prevBtn, 'click', function() { wrap.scrollBy({ left: -280, behavior: 'smooth' }); });
      on(nextBtn, 'click', function() { wrap.scrollBy({ left: 280, behavior: 'smooth' }); });
    }
  });

  // ---- Product Gallery Thumbnails ----
  var gallery = $('.product-gallery');
  if (gallery) {
    var mainImg = gallery.querySelector('.product-gallery__main img');
    var thumbs = $$('.product-gallery__thumb', gallery);
    thumbs.forEach(function(thumb) {
      on(thumb, 'click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) {
          var fullSrc = thumb.getAttribute('data-full-src');
          var altText = thumb.getAttribute('data-alt');
          mainImg.src = fullSrc || thumb.querySelector('img').src;
          if (altText) mainImg.alt = altText;
        }
      });
    });
  }

  // ---- Product Tabs ----
  $$('.product-info__tab-btn').forEach(function(btn) {
    on(btn, 'click', function() {
      var tabId = btn.dataset.tab;
      $$('.product-info__tab-btn').forEach(function(b) { b.classList.remove('active'); });
      $$('.product-info__tab-content').forEach(function(c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var content = document.getElementById('Tab-' + tabId);
      if (content) content.classList.add('active');
    });
  });

  // ---- Back to Top ----
  var backToTop = $('#BackToTop');
  on(window, 'scroll', function() {
    if (!backToTop) return;
    backToTop.style.display = window.scrollY > 400 ? 'flex' : 'none';
  });
  on(backToTop, 'click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  // ---- Sticky Header ----
  var siteHeader = $('#SiteHeader');
  on(window, 'scroll', function() {
    if (!siteHeader) return;
    if (window.scrollY > 10) siteHeader.classList.add('scrolled');
    else siteHeader.classList.remove('scrolled');
  });

  // ---- Mobile Menu ----
  var mobileToggle = $('#MobileMenuToggle');
  var mobileClose = $('#MobileMenuClose');
  var mobileMenu = $('#MobileMenu');
  var mobileOverlay = $('#MobileMenuOverlay');

  function openMobile() { if (mobileMenu) { mobileMenu.style.transform = 'translateX(0)'; if (mobileOverlay) mobileOverlay.style.display = 'block'; document.body.style.overflow = 'hidden'; } }
  function closeMobile() { if (mobileMenu) { mobileMenu.style.transform = 'translateX(-100%)'; if (mobileOverlay) mobileOverlay.style.display = 'none'; document.body.style.overflow = ''; } }
  on(mobileToggle, 'click', openMobile);
  on(mobileClose, 'click', closeMobile);
  on(mobileOverlay, 'click', closeMobile);

  // ---- Variant Selector ----
  on(document, 'change', function(e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var form = select.closest('[data-product-form]');
    if (!form) return;
    var variantId = select.value;
    var hiddenInput = form.querySelector('[name="id"]');
    if (hiddenInput) hiddenInput.value = variantId;
  });

  // ---- Intersection Observer for animations ----
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    $$('[data-animate]').forEach(function(el) { observer.observe(el); });
  }

  // ---- Init ----
  fetchCart();

})();

  // ============================================================
  // TRANSPARENT HEADER — becomes solid on scroll
  // ============================================================
  (function() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    var isTransparent = header.classList.contains('site-header--transparent');
    if (!isTransparent) return;

    // Add body class so hero can fill viewport
    document.body.classList.add('has-transparent-header');

    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // ============================================================
  // HERO BANNER SLIDER
  // ============================================================
  (function() {
    var banner = document.getElementById('HeroBanner');
    if (!banner) return;
    var slides = Array.from(banner.querySelectorAll('.hero-banner__slide'));
    if (slides.length <= 1) return;

    var current = 0;
    var autoplayTimer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      autoplayTimer = setInterval(next, 5000);
    }
    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    var btnNext = document.getElementById('HeroNext');
    var btnPrev = document.getElementById('HeroPrev');
    if (btnNext) btnNext.addEventListener('click', function() { stopAutoplay(); next(); startAutoplay(); });
    if (btnPrev) btnPrev.addEventListener('click', function() { stopAutoplay(); prev(); startAutoplay(); });

    // Touch swipe support
    var touchStartX = 0;
    banner.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    banner.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { stopAutoplay(); diff > 0 ? next() : prev(); startAutoplay(); }
    }, { passive: true });

    startAutoplay();
  })();

// end of yoome.js
